const userAgent = navigator.userAgent;
export const IS_IOS = /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const IS_ANDROID = /android/i.test(userAgent);
//# sourceMappingURL=mobileOs.js.map